import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'Les paris en ligne sont-ils légaux en France ?',
      answer: 'Oui, les paris en ligne sont parfaitement légaux en France depuis 2010. Les opérateurs doivent être agréés par l\'Autorité Nationale des Jeux (ANJ) pour proposer leurs services aux résidents français. Tous les sites que nous recommandons possèdent cette autorisation.',
    },
    {
      question: 'Comment choisir le meilleur site de paris ?',
      answer: 'Plusieurs critères sont à considérer : la réputation de l\'opérateur, la rapidité des retraits, la variété des sports et marchés proposés, la qualité des cotes, les bonus disponibles et le service client. Notre équipe teste chaque plateforme pour vous faciliter le choix.',
    },
    {
      question: 'Les bonus de bienvenue sont-ils vraiment avantageux ?',
      answer: 'Les bonus de bienvenue peuvent être intéressants s\'ils correspondent à votre style de jeu. Attention cependant aux conditions de mise (wager) qui peuvent être élevées. Nous analysons chaque offre pour vous indiquer si elle vaut vraiment le coup.',
    },
    {
      question: 'Combien de temps faut-il pour retirer ses gains ?',
      answer: 'Les délais varient selon les opérateurs et la méthode de retrait choisie. Les virements bancaires prennent généralement 2 à 5 jours ouvrés, tandis que les portefeuilles électroniques comme PayPal ou Skrill sont souvent plus rapides (24-48h).',
    },
    {
      question: 'Puis-je parier depuis mon mobile ?',
      answer: 'Absolument. Tous les sites recommandés proposent des applications mobiles ou des versions optimisées pour smartphones et tablettes. Vous pouvez parier en direct depuis n\'importe où, à condition d\'être connecté à internet.',
    },
    {
      question: 'Que faire en cas de problème avec un opérateur ?',
      answer: 'Contactez d\'abord le service client de l\'opérateur. Si le problème persiste, vous pouvez saisir le médiateur des jeux en ligne ou l\'ANJ. Nous recommandons uniquement des plateformes avec un service client réactif et des procédures de réclamation claires.',
    },
  ];

  return (
    <section id="faq" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Questions fréquentes
          </h2>
          <p className="text-xl text-gray-600">
            Les réponses aux questions que vous vous posez le plus souvent
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden"
            >
              <button
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              >
                <span className="font-semibold text-gray-900 pr-8">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="text-primary-red flex-shrink-0" size={24} />
                ) : (
                  <ChevronDown className="text-gray-400 flex-shrink-0" size={24} />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

